/** Return correctly typed keys from an object with type-branded keys */
export function brandedKeys(obj) {
    return Object.keys(obj);
}
/** Return correctly typed entries from an object with type-branded keys */
export function brandedEntries(obj) {
    return Object.entries(obj);
}
/** Return correctly-type values from an object with type-branded keys
 * Note: in theory, we shouldn't need this because only the keys are
 * branded, not the values. But the builtin Object.values() doesn't
 * play nicely with branded keys, and ends up return an `any[]`.
 * Lodash's `.values()` works well, but for symmetry and clear intent
 * I'm including brandedValues here too.
 */
export function brandedValues(obj) {
    return Object.values(obj);
}
//# sourceMappingURL=brandedObjectEntries.js.map